var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.998535 0.999944C0.998535 0.447644 1.44618 0 1.99848 0H10.9985V1.99989H2.99834V18.0002H18.9986V10H20.9985V19.0001C20.9985 19.5524 20.5509 20 19.9986 20H1.99857C1.44626 20 0.998621 19.5524 0.998621 19.0001L0.998535 0.999944Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0747 0C17.3399 0 17.5942 0.1053 17.7818 0.2928L20.7087 3.21965C21.0991 3.61022 21.0991 4.24338 20.7087 4.63393L11.9281 13.4145C11.7627 13.5799 11.5446 13.6822 11.3115 13.7033L8.09204 13.9961C7.79639 14.0231 7.50425 13.9173 7.29434 13.7073C7.08457 13.4976 6.97877 13.2052 7.00555 12.9096L7.29819 9.69014C7.31945 9.45711 7.42157 9.23899 7.58714 9.07356L16.3677 0.292972C16.5552 0.105472 16.8095 0.000171498 17.0747 0.000171498V0ZM15.8548 3.63416L17.3675 5.14672L18.5874 3.92679L17.0747 2.41423L15.8548 3.63416ZM15.9532 6.56101L14.4405 5.04828L9.25732 10.2314L9.10615 11.8953L10.77 11.7441L15.9532 6.56101Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLarge);
export default __webpack_public_path__ + "static/media/edit_large.ef6bc29f867a9069dab69e11b1477402.svg";
export { ForwardRef as ReactComponent };